import React, { useState, useEffect } from 'react'
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import { Form as FormUi, Container, Segment, Grid, Checkbox, Radio, Dropdown, Button, GridColumn } from "semantic-ui-react";
import { MyInput, MyNormalInput } from "../../../dynamicComponent/myInputs";
import AddTitleBar from '../../../titleBar/add_titleBar';
import SearchDropdown from '../../../createShipmentComponent/searchDropdown';
import ViewAvailability from './viewAvailability';
import { translate } from "react-i18next";
import MyCity from '../../../dynamicComponent/myCity';
import { DateData } from '../../../dynamicComponent/datepick';
import CreateAxios from "../../../axiosComponent/create";
import ReadAxios from '../../../axiosComponent/read';
import { AllRegex } from "../../../../utils/validation";
import moment from 'moment';
import * as yup from "yup";
import cogoToast from 'cogo-toast';

const MyForm = ({
    values,
    touched,
    errors,
    handleChange,
    setFieldValue,
    handleBlur,
    handleSubmit,
    onlyAddVehicle,
    fromAdmin,
    t
}) => {

    const [vendor_value, setvendor_value] = useState(0);
    const [cityId, setCityId] = useState(0);
    const [load, setLoad] = useState([]);
    const [vehicleItems, setvehicleItems] = useState([]);
    const [isloading, setLoading] = useState(false);
    const [ownVendor, setOwnVendor] = useState(false);

    useEffect(() => {
        setvendor_value(localStorage.getItem("vendorId"))
        getLoadType()
        getvehicleType()
        getOwnVendors()
    }, [])

    let fetchCityInfo = (data) => {
        setCityId(data.city_id)
    }

    let handleSubmitting = () => {
        if (cityId) {
            values.city_id = cityId
        }
        // handleSubmit()
    };

    const getvehicleType = () => {
        CreateAxios({
            completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleTypeMaster`
        }).then((res) => {
            if (res.status === 200) {
                let vehicles = res.data.resultSet.map((item, index) => {
                    return {
                        key: index + 1,
                        text: item.vehicleType,
                        value: item.vehicleTypeId,
                        raw: { ...item },
                    };
                })

                setvehicleItems(vehicles)

            }
        })
    }

    const getLoadType = () => {
        setLoading(true);
        ReadAxios({
            completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type`,
        })
            .then((res) => {
                setLoading(false);
                let load = [];

                let loadtypeRes = res.data.data

                if (localStorage.getItem('customerNumber') == 549) {
                    loadtypeRes.forEach(element => {
                        if (element.load_type_name == "Frozen") {
                            element.load_type_name = 'Reefer'
                        }
                    });
                    let newLoadType = loadtypeRes.filter((type) => {
                        if (type.load_type_name == "Reefer" || type.load_type_name == "Dry") {
                            return type
                        }
                    })

                    load = newLoadType;
                }
                else {
                    load = loadtypeRes;
                }

                setLoad(
                    load.map((item, index) => {
                        return {
                            key: index,
                            value: item.load_type_id,
                            text: item.load_type_name,
                            raw: { ...item },
                        };
                    }))
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const getOwnVendors = () => {
        CreateAxios({
            completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster`,
        }).then((result) => {
            let tempown = [];
            let vendorData = result.data.resultSet;
            for (let index = 0; index < vendorData.length; index++) {
                if (vendorData[index].vendorOwnershipType == 1) {
                    tempown.push(vendorData[index]);
                }
            }
            setOwnVendor(
                tempown.map((item, index) => {
                    return {
                        key: index + 1,
                        text: item.transporterName,
                        value: item.transporterMasterId,
                        raw: { ...item },
                    };
                })
            );
        })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <React.Fragment>
            <AddTitleBar Title={t("table_header.vehicle_number") || "Vehicle Availability"} hideClose="true" />

            <Formiker>
                <div className="ui Container">

                    <Segment>

                        <FormUi.Group inline>
                            <FormUi.Field>

                                <Grid columns={3} stackable className="width-100cent margin-left-20">
                                    {/* <Grid columns={6} stackable className="width-100cent margin-left-20"> */}
                                    {onlyAddVehicle != null && onlyAddVehicle != undefined && !onlyAddVehicle ?
                                        <Grid.Column>
                                            <label className="labelName">
                                                {t("table_header.vendor_name") || "Partner"} *
                                            </label>

                                            {onlyAddVehicle != null && onlyAddVehicle != undefined && !onlyAddVehicle ?
                                                <>
                                                    <Dropdown
                                                        clearable
                                                        style={{ width: "100%", fontWeight: "normal" }}
                                                        search
                                                        selection

                                                        defaultValue={values.vendor_id}
                                                        onChange={(name, data) => {
                                                            setFieldValue("vendor_id", data.value)
                                                            if (fromAdmin != null && fromAdmin != undefined && fromAdmin == true) setvendor_value(data.value)
                                                        }
                                                        }
                                                        options={ownVendor}
                                                    />

                                                </>
                                                : null}
                                        </Grid.Column>
                                        : null}
                                    <Grid.Column>
                                        <label className="labelName">
                                            {t("table_header.vehicle_number") || "Vehicle Number"} *
                                        </label>
                                        <div className="master-with-search">
                                        <SearchDropdown
                                            setField={(name, value) => {
                                                console.log('>>>', value.raw ? value.raw.vehicleTypeId : '');
                                                setFieldValue(`vehicle_number`, value.raw ? value.raw.vehicleNumber : value)
                                                setFieldValue(`vehicle_type_id`, value.raw ? value.raw.vehicleTypeId : "")
                                            }}
                                            masterRoute={"vendorMaster/vehicles/" + vendor_value}
                                            masterRouteKey="vehicleId"
                                            masterRouteName="vehicleNumber"
                                            portal="vendor-web"
                                            fluid
                                            fieldName="vehicle_number"
                                            style={{ fontWeight: "normal;" }}
                                            maxLength="10"
                                            
                                        />

                                        {touched.vehicle_number && errors.vehicle_number ? (
                                            <p className="error-msg">
                                                {
                                                    "Enter correct vehicle details."
                                                }
                                            </p>
                                        ) : null}
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column className="width_adjust_100">
                                        <label className="labelName">
                                            {t("table_header.vehicle_type") || "Vehicle Type"}
                                        </label>
                                        <Dropdown
                                            name={`vehicle_type_id`}
                                            // style={{ width: "70%" }}
                                            selection
                                            onChange={(name, data) => {
                                                console.log(data.value);
                                                setFieldValue("vehicle_type_id", data.value)
                                            }}
                                            options={vehicleItems}
                                            error={
                                                touched.vehicle_type_id && errors.vehicle_type_id
                                                    ? true
                                                    : false
                                            }
                                            value={values.vehicle_type_id}
                                        />
                                        {touched.vehicle_type_id && errors.vehicle_type_id ? (
                                            <div className="fontSmall" style={{ color: 'red' }}>
                                                {
                                                    errors.vehicle_type_id}
                                            </div>
                                        ) : null}
                                    </Grid.Column>
                                    <Grid.Column>
                                        <label className="labelName">
                                            {t("table_header.city") || "City"}
                                        </label>
                                        <Fieldmik component={MyCity} getCityInfo={fetchCityInfo} name="city_id" />
                                        {touched.city_id && errors.city_id ? <div className="fontSmall" style={{ color: 'red' }}>
                                            {
                                                errors.city_id
                                            }
                                        </div>
                                            : null}
                                    </Grid.Column>
                                    <Grid.Column>
                                        <label className="labelName">
                                            {t("table_header.start_date") || "Availability Start Date & Time"}
                                        </label>
                                        <DateData
                                            name="availability_start_time"
                                            autoComplete="off"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            timeIntervals={5}
                                            customInput={
                                                <FormUi.Input
                                                    icon="time"
                                                    className="dateWidth"
                                                    iconPosition="left"
                                                />
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSubmitting(handleSubmit())
                                                }
                                            }}
                                        />
                                        {touched.availability_start_time && errors.availability_start_time ? (
                                            <div className="fontSmall" style={{ color: 'red' }}>
                                                {
                                                    errors.availability_start_time}
                                            </div>
                                        ) : null}
                                    </Grid.Column>

                                    <Grid.Column>
                                        <label className="labelName">
                                            {t("table_header.end_date") || "Availability End Date & Time"}
                                        </label>
                                        <DateData
                                            name="availability_end_time"
                                            autoComplete="off"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            timeIntervals={5}
                                            customInput={
                                                <FormUi.Input
                                                    icon="time"
                                                    className="dateWidth"
                                                    iconPosition="left"
                                                />
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSubmitting(handleSubmit())
                                                }
                                            }}
                                        />{touched.availability_end_time && errors.availability_end_time ? (
                                            <div className="fontSmall" style={{ color: 'red' }}>
                                                {
                                                    errors.availability_end_time}
                                            </div>
                                        ) : null}

                                    </Grid.Column>


                                    
                                    <Grid.Column>
                                        <label className="labelName">
                                            {t("table_header.load_type") || "Load Type"}
                                        </label>
                                        <Dropdown
                                            clearable
                                            style={{ width: "100%", fontWeight: "normal" }}
                                            search
                                            loading={isloading}
                                            selection
                                            defaultValue={
                                                values.load_type
                                            }
                                            onChange={(name, data) =>
                                                setFieldValue("load_type_id", data.value)
                                            }
                                            options={load}
                                        />{touched.load_type_id && errors.load_type_id ? (
                                            <div className="fontSmall" style={{ color: 'red' }}>
                                                {
                                                    errors.load_type_id}
                                            </div>
                                        ) : null}
                                    </Grid.Column>




                                    {values.load_type_id == "2" || values.load_type_id == "1" || values.load_type_id == "3" ?
                                        <>
                                            <Grid.Column>
                                                <label className="labelName">
                                                    {t("table_header.temp_min") || "Minimum Temperature"}
                                                </label>
                                                <FormUi.Field width={3}>
                                                    <Fieldmik style={{ width: "100%" }} type="number" component={MyNormalInput} name="min_temp" />
                                                    {touched.min_temp && errors.min_temp ? (
                                                        <div className="fontSmall" style={{ color: 'red' }}>
                                                            {
                                                                errors.min_temp}
                                                        </div>
                                                    ) : null}
                                                </FormUi.Field>
                                            </Grid.Column>

                                            <Grid.Column>
                                                <label className="labelName">
                                                    {t("table_header.temp_max") || "Maximum Temperature"}
                                                </label>
                                                <FormUi.Field width={3}>
                                                    <Fieldmik style={{ width: "100%" }} type="number" component={MyNormalInput} name="max_temp" />
                                                    {touched.max_temp && errors.max_temp ? (
                                                        <div className="fontSmall" style={{ color: 'red' }}>
                                                            {
                                                                errors.max_temp}
                                                        </div>
                                                    ) : null}
                                                </FormUi.Field>
                                            </Grid.Column>
                                        </>
                                        : ""}
                                    



                                    {/* {onlyAddVehicle != null && onlyAddVehicle != undefined && !onlyAddVehicle ?
                                    <>
                                        <FormUi.Field width={3}>
                                            <Dropdown
                                                clearable
                                                style={{ width: "100%", fontWeight: "normal" }}
                                                search
                                                selection

                                                defaultValue={values.vendor_id}
                                                onChange={(name, data) => {
                                                    setFieldValue("vendor_id", data.value)
                                                    if (fromAdmin != null && fromAdmin != undefined && fromAdmin == true) setvendor_value(data.value)
                                                }
                                                }
                                                options={ownVendor}
                                            />
                                        </FormUi.Field>
                                    </>
                                    : null} */}

                                    {/* <FormUi.Field width={3} className="display-grid-center">
                                    <SearchDropdown
                                        setField={(name, value) => {
                                            console.log('>>>', value.raw ? value.raw.vehicleTypeId : '');
                                            setFieldValue(`vehicle_number`, value.raw ? value.raw.vehicleNumber : value)
                                            setFieldValue(`vehicle_type_id`, value.raw ? value.raw.vehicleTypeId : "")
                                        }}
                                        masterRoute={"vendorMaster/vehicles/" + vendor_value}
                                        masterRouteKey="vehicleId"
                                        masterRouteName="vehicleNumber"
                                        portal="vendor-web"
                                        fieldName="vehicle_number"
                                        maxLength="10"
                                    />

                                    {touched.vehicle_number && errors.vehicle_number ? (
                                        <p className="error-msg">
                                            {
                                                "Enter correct vehicle details."
                                            }
                                        </p>
                                    ) : null}
                                </FormUi.Field> */}

                                    {/* <FormUi.Field width={3}>
                                    <Dropdown
                                        name={`vehicle_type_id`}
                                        style={{ width: "70%" }}
                                        selection
                                        onChange={(name, data) => {
                                            console.log(data.value);
                                            setFieldValue("vehicle_type_id", data.value)
                                        }}
                                        options={vehicleItems}
                                        error={
                                            touched.vehicle_type_id && errors.vehicle_type_id
                                                ? true
                                                : false
                                        }
                                        value={values.vehicle_type_id}
                                    />
                                    {touched.vehicle_type_id && errors.vehicle_type_id ? (
                                        <div className="fontSmall" style={{ color: 'red' }}>
                                            {
                                                errors.vehicle_type_id}
                                        </div>
                                    ) : null}
                                </FormUi.Field> */}

                                    {/* <FormUi.Field width={3}>
                                    <Dropdown
                                        clearable
                                        style={{ width: "100%", fontWeight: "normal" }}
                                        search
                                        loading={isloading}
                                        selection
                                        defaultValue={
                                            values.load_type
                                        }
                                        onChange={(name, data) =>
                                            setFieldValue("load_type_id", data.value)
                                        }
                                        options={load}
                                    />{touched.load_type_id && errors.load_type_id ? (
                                        <div className="fontSmall" style={{ color: 'red' }}>
                                            {
                                                errors.load_type_id}
                                        </div>
                                    ) : null}
                                </FormUi.Field> */}

                                    {/* {values.load_type_id == "2" || values.load_type_id == "1" || values.load_type_id == "3" ?
                                    <>
                                        <FormUi.Field width={3}>
                                            <Fieldmik style={{ width: "100%" }} type="number" component={MyNormalInput} name="min_temp" />
                                            {touched.min_temp && errors.min_temp ? (
                                                <div className="fontSmall" style={{ color: 'red' }}>
                                                    {
                                                        errors.min_temp}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>

                                        <FormUi.Field width={3}>
                                            <Fieldmik style={{ width: "100%" }} type="number" component={MyNormalInput} name="max_temp" />
                                            {touched.max_temp && errors.max_temp ? (
                                                <div className="fontSmall" style={{ color: 'red' }}>
                                                    {
                                                        errors.max_temp}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>
                                    </>
                                    : ""} */}


                                    {/* <FormUi.Group inline>
                                <FormUi.Field width={3}>
                                    <label className="labelName fontSmall">
                                        {t("table_header.city") || "City"}
                                    </label>
                                </FormUi.Field>

                                <FormUi.Field width={3}>
                                    <label className="labelName fontSmall  p-bold-600">
                                        {t("table_header.start_date") || "Availability Start Date & Time"}
                                    </label>
                                </FormUi.Field>

                                <FormUi.Field width={3}>
                                    <label className="labelName fontSmall">
                                        {t("table_header.end_date") || "Availability End Date & Time"}
                                    </label>
                                </FormUi.Field>
                            </FormUi.Group> */}
                                    {/* <FormUi.Group> */}
                                    {/* <FormUi.Field width={3}>
                                    <Fieldmik component={MyCity} getCityInfo={fetchCityInfo} name="city_id" />
                                    {touched.city_id && errors.city_id ? <div className="fontSmall" style={{ color: 'red' }}>
                                        {
                                            errors.city_id
                                        }
                                    </div>
                                        : null}
                                </FormUi.Field> */}

                                    {/* <FormUi.Field width={3}> */}
                                    {/* <DateData
                                        name="availability_start_time"
                                        autoComplete="off"
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        popperClassName="dateTime"
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        timeIntervals={5}
                                        customInput={
                                            <FormUi.Input
                                                icon="time"
                                                className="dateWidth"
                                                iconPosition="left"
                                            />
                                        }
                                    />
                                    {touched.availability_start_time && errors.availability_start_time ? (
                                        <div className="fontSmall" style={{ color: 'red' }}>
                                            {
                                                errors.availability_start_time}
                                        </div>
                                    ) : null} */}
                                    {/* </FormUi.Field> */}

                                    {/* <FormUi.Field width={3}> */}
                                    {/* <DateData
                                        name="availability_end_time"
                                        autoComplete="off"
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        popperClassName="dateTime"
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        timeIntervals={5}
                                        customInput={
                                            <FormUi.Input
                                                icon="time"
                                                className="dateWidth"
                                                iconPosition="left"
                                            />
                                        }
                                    />{touched.availability_end_time && errors.availability_end_time ? (
                                        <div className="fontSmall" style={{ color: 'red' }}>
                                            {
                                                errors.availability_end_time}
                                        </div>
                                    ) : null} */}
                                    {/* </FormUi.Field> */}
                                    {/* </FormUi.Group> */}
                                </Grid>
                                <Grid columns={4}>
                                <Grid.Column></Grid.Column>
                                <Grid.Column></Grid.Column>
                                    <Grid.Column>
                                        <Button onClick={handleSubmitting} type="submit"
                                            className="mt-1" primary size="mini">{t("action_button.submit") || "Submit"}</Button>
                                    </Grid.Column>
                                    <Grid.Column></Grid.Column>
                                </Grid>
                            </FormUi.Field>

                        </FormUi.Group>
                    </Segment>
                </div>



            </Formiker>
            {onlyAddVehicle != null && onlyAddVehicle != undefined && !onlyAddVehicle ?
                null
                :
                <ViewAvailability />
            }
        </React.Fragment>
    );
};

const AddAvailability = withFormik({

    mapPropsToValues({ vendor_id, city_id, load_type_id, availability_end_time, availability_start_time, max_temp, min_temp }) {
        return {
            vendor_id: null,
            city_id: city_id || "",
            vehicle_number: null,
            load_type_id: load_type_id || "",
            availability_end_time: availability_end_time || "",
            availability_start_time: availability_start_time || "",
            min_temp: min_temp || "",
            max_temp: max_temp || ""
        };
    },

    // Custom sync validation
    validationSchema: yup.object({
        city_id: yup.string().required('Required'),
        load_type_id: yup.string().required('Required'),
        availability_end_time: yup.string().required('Required'),
        availability_start_time: yup.string().required('Required'),
        vehicle_number: yup.string().optional().matches(AllRegex.VehicleNumber, "vehicle_number"),
        max_temp: yup.number().optional().min(yup.ref('min_temp', 'max temp must'), 'Max Temp must be greater than min temp'),
        min_temp: yup.number().optional().when("max_temp", (max_temp) =>
            max_temp
                ? yup.number().optional().nullable().max(yup.ref('max_temp', 'max temp must'), 'Min Temp must be lesser than max temp')
                : yup.number().optional().nullable()
        ),

    }),
    //  endValue: Yup.number().when('startValue', (startValue, schema) => (startValue === null ? schema.typeError('Only Numbers Required') : schema.min(startValue + 1, 'Should be more than Start Value'))).required('Required'),
    handleSubmit(values, { setSubmitting, props }) {
        values.vendor_id = values.vendor_id ? values.vendor_id : +localStorage.getItem("vendorId")
        if (values.max_temp == "")
            values.max_temp = null
        if (values.min_temp == "")
            values.min_temp = null
        values.availability_start_time = moment.parseZone(values.availability_start_time).format('YYYY-MM-DD HH:mm:ss')
        values.availability_end_time = moment.parseZone(values.availability_end_time).format('YYYY-MM-DD HH:mm:ss')

        let payload = values
        CreateAxios({
            completeURL: `${process.env.REACT_APP_TA_API_URL}/vehicle/availability`, payload
        }).then((res) => {
            setSubmitting(false);
            cogoToast.success("Successfully added")
            window.location.reload();
        }).catch((err) => {
            console.log(err);
            let error_msg = err.response ? err.response.data.message : (err.message ? err.message : "Server Error")
            cogoToast.error(error_msg)
        });
    },

    displayName: 'BasicForm',
})(MyForm);

export default (translate("alloted_vehicle_details")(AddAvailability));